<template>
    <div>
        <div  ref="chart" class="chart"></div>
    </div>
</template>
<script>

export default ({
    name:'cebao',
    data(){
        return{

        }
    },
    mounted(){
        this.initCharts();
    },
    methods:{
        initCharts () {
        　　let myChart = this.$echarts.init(this.$refs.chart);
        　　console.log(this.$refs.chart)
　　        // 绘制图表
            　　myChart.setOption({
                    　　title: { 
                            text: '测报数据' ,
                            y:'top',
                            x:'left',
                            textStyle:{
                                fontSize:15,
                                fontWeight:'bolder',
                                color:'black'
                            }
                        },
                    　　tooltip: {},
                        legend:{
                            data:['茶小绿叶蝉'],
                            textStyle:{//图例文字的样式
                            color:'black',
                            
                        }

                        },
                    　　xAxis: {
                    　　    data: ["2021.11.01","2021.11.02","2021.11.03"],
                            axisLine: {//x轴线的颜色以及宽度
                                        show: true,
                                        lineStyle: {
                                            color: "black",
                                            width: 0,
                                            type: "solid"
                                        }
                                    }
                    　　},
                    　　yAxis: {},
                    　　series: [{
                            　　name: '茶小绿叶蝉',
                            　　type: 'bar',
                            　　data: [5, 20, 36],
                                barWidth: 15,
                                itemStyle: { //柱状颜色和圆角
                                    color: '#00FFFF',
                                    barBorderRadius: [5, 5, 0, 0], // （顺时针左上，右上，右下，左下）
                                },
                    　　}]
            　　});
　　    }
    }
})
</script>
<style scoped>
.select{
border: black 1px solid;
}
#cbselect{
margin-left: 5%;
background-color: #87CEFA;
border: none;
}
.chart{
    width:280px;
    height:280px;
    float: right;
}
</style>
